import * as React from 'react';
import styled from 'styled-components';

import { DotLoadingIndicator } from '@xing-com/dot-loading-indicator';
import { scale190 } from '@xing-com/tokens';

import { MentionableUser } from './mentionable-user';
import type { handleMentionSelectionType, MentionUser } from './types';

export type PopoverContentProps = {
  index: number;
  loading: boolean;
  onMouseDown: handleMentionSelectionType;
  users: MentionUser[];
};

export const PopoverContent: React.FC<PopoverContentProps> = ({
  index,
  loading,
  onMouseDown,
  users,
}) => (
  <React.Fragment>
    {loading ? (
      <StyledPopoverLoader />
    ) : (
      users.map((user, mapIndex) => (
        <MentionableUser
          key={user.userId}
          {...{ onMouseDown, mapIndex, index, user }}
        />
      ))
    )}
  </React.Fragment>
);

const StyledPopoverLoader = styled(DotLoadingIndicator)`
  justify-content: center;
  align-self: center;
  height: ${scale190};
`;
